<template>
    <div id="articles" class="container">
      <div class="section-title">حكــي جـرايــد</div>
      <ul>
        <li v-for="(article,index) in articles" v-if="index <= nArticles" :key="article.id">
          <div class="spacer"></div>
          <a class="title" :href="article.articleLink" v-html="article.articleTitle" target="_blank"></a>
          <div class="article-date">{{article.articleDate}}</div>
        </li>
      </ul>
      <div class="load-more" v-if="loadMoreCheck" @click="loadMore">المزيد</div>
    </div>
</template>

<script>
export default {
  data () {
      return {
        articles: '',
        nArticles: 7,
        loadMoreCheck:true,
        windowWidth:''
      }
  },
  computed: {
    getWindowWidth() {
        this.windowWidth = document.documentElement.clientWidth;
    },
    getnArticles(){
      if(this.windowWidth < 767){
        this.nArticles = 5
      } else{
        this.nArticles = 8
      }
    }
  },
  methods: {
    loadMore(){
      this.nArticles = this.nArticles + 4
      console.log(this.articles.length)
      if (this.articles.length <= this.nArticles ){
        this.loadMoreCheck = false;
      }
    }
  },
  created () {
    this.$http.get('https://cms.zaidounk.com/api/articles')
    .then(result => {
        return result.json()
    })
    .then(data => {
        this.articles = data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sections/Articles.vue